import { call, put, takeLatest, all } from "redux-saga/effects";

import {
  ADMIN_CLIENTS_GET_ALL_REQUESTING,
  ADMIN_CLIENTS_GET_ALL_SUCCESS,
  ADMIN_CLIENTS_GET_ALL_ERROR
} from "./constants";

import { fetchApi } from "../api";

const apiEndpoints = {
  getAllClientsList: "/v1/clients/all-list"
};

const getAllClients = () => {
  return fetchApi(apiEndpoints.getAllClientsList, {}, "post");
};

function* getAllClientsSaga(action) {
  try {
    const clients = yield call(getAllClients);
    yield put({ type: ADMIN_CLIENTS_GET_ALL_SUCCESS, payload: clients });
  } catch (error) {
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      default:
        message = "Something went wrong";
    }
    yield put({ type: ADMIN_CLIENTS_GET_ALL_ERROR, payload: message });
  }
}

function* Saga() {
  yield all([takeLatest(ADMIN_CLIENTS_GET_ALL_REQUESTING, getAllClientsSaga)]);
}

export default Saga;
